import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import { Link } from '@material-ui/core';
import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined';
import Header from '../../components/Header';
import PublicHeader from '../../components/PublicHeader';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  GET_LIST_SETTING_MENU_FREE_SUCCESS,
  getListSettingMenuFree
} from '../../actions/GochiMenus';
import { getAccounts } from '../../actions/Accounts';
import MenuBox from '../../components/MenuBox';
import TabPanelDetail from '../../components/atoms/TabPanelDetail';
import HelpGochiKidShopDialog from '../../components/molecules/HelpGochiKidShopDialog';
import GochiKidMenuFreeTableShop from './GochiKidMenuFreeTableShop';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7'
    }
  },
  root: {
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    marginTop: 15
  },
  mainPaper: {
    position: 'relative',
    margin: 0,
    padding: 0
  },
  mainContent: {
    padding: '20px 15px',
    margin: '-35px -10px -15px'
  },
  fs24: {
    fontSize: '24px',
    fontWeight: 700
  },
  textCenter: {
    textAlign: 'center',
    padding: 15
  },
  bold: {
    fontWeight: 'bold'
  },
  buttonHelp: {
    justifyContent: 'flex-start',
    backgroundColor: 'transparent',
    minWidth: 'fit-content'
  },
  iconHelpEx: {
    color: 'gray !important',
    width: '20px',
    height: '20px'
  },
  titleHeader: {
    fontSize: 20,
    fontWeight: 700,
    padding: '20px 10px 5px'
  },
  divNoMenu: {
    padding: '5px 10px 15px'
  },
  titleNoMenu: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 15
  },
  contentNoMenu: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '25.6px'
  },
  divWarning: {
    display: 'flex',
    alignItems: 'flex-start',
    border: '1px solid #FFEEEF',
    borderRadius: 4,
    backgroundColor: '#FFEEEF',
    padding: 8,
    margin: '10px 0',
    fontSize: '13.5px',
    lineHeight: '22.4px'
  },
  iconWarning: {
    color: '#FF545C',
    marginRight: 4
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getListSettingMenuFree,
          getAccounts
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('hasMore', 'setHasMore', false),
  withState('nextHref', 'setNextHref', 1),
  withState('listMenus', 'setListMenus', []),
  withState('valueTab', 'setValueTab', 0),
  withState('openHelpGochiKid', 'setOpenHelpGochiKid', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => (event, page, limit) => {
      const searchKey = {
        page,
        limit
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getListSettingMenuFree(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
          let list = [];
          if (page > 1) {
            list = props.listMenus;
          } else {
            list = [];
            props.setNextHref(1);
          }

          if (data.type === GET_LIST_SETTING_MENU_FREE_SUCCESS) {
            if (data.payload.menus) {
              data.payload.menus.map(menu => {
                return list.push(menu);
              });
              props.setListMenus(list);
              if (data.payload.offset + 10 < data.payload.totalCount) {
                props.setHasMore(true);
              } else {
                props.setHasMore(false);
              }
            }
          }
        })
        .catch(error => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          console.log(error);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        this.props.handleChangePage(null, 1, 10);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    openTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    groupName,
    shopName,
    menuName,
    resultMessage,
    setResultMessage,
    page,
    hasMore,
    nextHref,
    setNextHref,
    listMenus,
    valueTab,
    openHelpGochiKid,
    setOpenHelpGochiKid
  }) => {
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupName,
      shopName,
      menuName,
      page,
      limit: limitNum
    };

    const loadMoreMenus = async () => {
      setNextHref(nextHref + 1);
      handleChangePage(null, nextHref + 1, 10);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    return (
      <div className={classes.root}>
        <CssBaseline />
        {isReleased ? <Header /> : <PublicHeader />}
        <div className={classes.pageTitileDiv}>
          <Typography color="textPrimary" className={classes.fs24}>
            こどもごちめし
          </Typography>
          <span className={classes.textHelpTitle}>こどもごちめし とは</span>
          <Button
            className={classes.buttonHelp}
            onClick={() => setOpenHelpGochiKid(true)}
          >
            <HelpIcon className={classes.iconHelpEx} />
          </Button>
        </div>
        <TabPanelDetail value={valueTab} index={0}>
          <div className={classes.mainContent}>
            <Paper className={classes.mainPaper} elevation={3}>
              <Typography className={classes.titleHeader}>
                無料メニュー設定状況
              </Typography>
              {listMenus.length > 0 ? (
                <>
                  {openTable && (
                    <GochiKidMenuFreeTableShop
                      searchKey={searchKey}
                      progress={progress}
                      page={page}
                      selectedPage={nextHref}
                      listMenus={listMenus}
                      account={account}
                    />
                  )}
                </>
              ) : (
                <>
                  {openTable && (
                    <div className={classes.divNoMenu}>
                      <div className={classes.titleNoMenu}>
                        無料メニュー設定とは？
                      </div>
                      <div className={classes.contentNoMenu}>
                        店舗様が費用を負担する事で、お子様に無料でお食事券を提供できる機能です。
                        <br />
                        店舗様で支援金をご用意いただける場合、こどもごちめしのご利用画面に支援元としてロゴマークなどを表示できます。
                        <br />
                        利用可能数や提供期間を設定でき、GOCHIプラットフォーム上でご利用数の管理ができます。こどもごちめしの寄付額が不足し「利用可能数：０」の場合もご利用いただけるので、独自で支援イベントを開催したい場合などに有用です。
                        <div className={classes.divWarning}>
                          <ErrorOutlinedIcon className={classes.iconWarning} />
                          利用されたお食事代金は店舗様負担となり、振込はありませんのでご了承ください。
                        </div>
                        お問い合わせ窓口宛にご相談いただければ、設定方法についてご相談を承ります。
                        <br />
                        お問い合わせ窓口：
                        <Link
                          href="https://support.gigi.tokyo/contact/for-store/"
                          target="_blank"
                          className={classes.supportLink}
                        >
                          https://support.gigi.tokyo/contact/for-store/
                        </Link>
                      </div>
                    </div>
                  )}
                </>
              )}
            </Paper>
            {hasMore && (
              <div className={classes.textCenter}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    loadMoreMenus();
                  }}
                >
                  もっと見る
                </Button>
              </div>
            )}
          </div>
        </TabPanelDetail>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        {isReleased && <MenuBox account={account} />}

        <HelpGochiKidShopDialog
          openHelpGochiKid={openHelpGochiKid}
          setOpenHelpGochiKid={setOpenHelpGochiKid}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
